<template>
  <!-- 贴吧首页 -->
  <div id="content"
       class="container">
    <header class="m15">
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('postBarList')">贴吧</div>
        <!-- <div class="el-icon-arrow-right jt"></div> -->
        <div class="integralBreadcrumb-item">{{dataForm.questionTitle}}</div>
      </div>
    </header>
    <!-- 全部问答 -->
    <div class="all-left-wrap">
      <div class="question-classify">
        <ul>
          <li v-for="(data,index) in dataTitle"
              :class="currentIndex===index?'checked':''"
              :key="index"
              @click="handleClick(index)">{{data}}</li>
        </ul>
      </div>
      <!-- 问答列表 -->
      <div class="question-list">
        <ul>
          <li v-for="data in dataList"
              :key="data.id">
            <!-- 头像 -->
            <div class="person">
              <img src="https://i-learning.supcon.com/static/supereduweb/img/avatar-boy.gif" />
              <p>{{data.email}}</p>
            </div>
            <!-- 右侧内容 -->
            <div class="question-con">
              <div class="question-left">
                <h3 @click="handleInfo(data.id)">{{data.questionTitle}}</h3>
                <p class="question-latest">
                  <span></span>
                  <span class="new-answer"
                        :class="data.bestContent?'best-answer':''">[{{data.bestContent?'最佳问答':'最新问答'}}]</span>
                  <span>{{data.bestContent?data.bestContent:data.newContent}}</span>
                </p>
                <div class="question-time">
                  <span>{{data.createTime}}</span>
                  <span :class="data.attributeList.length?'question-att':''"
                        v-for="item in data.attributeList"
                        :key="item">{{item}}</span>
                </div>
              </div>
              <div class="question-right">
                <div class="answer-number">
                  <p>{{data.replyCount}}</p>
                  <p>回答数</p>
                </div>
                <div class="review-number">
                  <p>{{data.viewCount}}</p>
                  <p>浏览数</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="doclist-pagination"
           v-if="dataList === [] || dataList.length !== 0">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="(item, index) in pageList"
              :key="index"
              @click="clickPageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">
          共{{totalPage}}页，到第
          <input type="text"
                 v-model.number="jumpTargetPage" />页
        </div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div>
    </div>
    <!-- 我要提问 -->
    <questionAsk @myevent="handleEvent"
                 ref="questionAsk"></questionAsk>
  </div>
</template>
<script>
import questionAsk from './questionAsk'
export default {
  data () {
    return {
      dataTitle: ['最新', '热门', '等待问答'],
      dataForm: {
        tag: 1,
        tagId: null
      },
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      totalData: 0,
      dataListLoading: false,
      currentIndex: 0,
      dataList: [],
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1
    }
  },
  components: {
    questionAsk
  },
  watch: {
    '$route.query': {
      handler: 'routerWatchFun'
    }
  },
  mounted () {
    if (this.$route.query.page) {
      let postBarSearch = this.$route.query
      this.currentPage = Number(postBarSearch.page)
      this.changePageTo(this.currentPage)
      this.dataForm.tag = postBarSearch.tag
      this.dataForm.tagId = postBarSearch.tagId
      this.currentIndex = Number(postBarSearch.currentIndex)
      this.$nextTick(() => {
        if (postBarSearch.childIndex) {
          this.$refs.questionAsk.setSearch(postBarSearch.childIndex)
        }
      })
    }
    if (this.$route.query.tagId !== null) {
      this.dataForm.tagId = this.$route.query.tagId
    }
    if (this.$route.query.tagIndex) {
      this.$refs.questionAsk.currentIndex = parseInt(this.$route.query.tagIndex)
    }
    this.getList()
  },
  methods: {
    routerWatchFun () {
      this.getList()
    },
    routerPush (params = {}) {
      let query = {
        page: 1,
        limit: 10,
        tag: this.$route.query.tag || 1,
        tagId: this.$route.query.tagId || null,
        currentIndex: this.$route.query.currentIndex || 0,
        ...params,
      }
      this.$router.push({
        name: 'postBarList',
        query: query
      })
    },
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'postBarList') {
        this.dataForm.tag = 1
        this.dataForm.tagId = null
        this.$refs.questionAsk.currentIndex = null
        this.$router.push({ name: 'postBarList' })
        this.getList()
      }
    },
    handleClick (index) {
      this.currentPage = 1
      this.currentIndex = index
      this.dataForm.tag = index + 1
      this.changePageTo(this.currentPage)
      this.routerPush({
        tag: this.dataForm.tag,
        currentIndex: this.currentIndex
      })
      // this.getList()
    },
    getList (page = this.currentPage) {
      let params = {}
      if (this.$route.query.page) {
        params = {
          ...this.$route.query,
          page: Number(this.$route.query.page),
          limit: Number(this.$route.query.limit)
        }
      } else {
        params = {
          page: 1,
          limit: 10,
          tag: 1,
          tagId: null
        }
      }
      this.$http.post(`/front/train/trainQuestionAnswer/postBarListPage`, params).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataList = res.data.data
          this.totalData = res.data.count
          // 分页
          this.totalPage = Math.ceil(res.data.count / 10)
          this.changePageTo(page)
        }
      })
      this.jumpTargetPage = 1
    },
    handleInfo (id) {
      this.$http.post(`/front/train/trainQuestionAnswer/plusViewCount`,
        {
          type: 4, // type --1:新闻/2：课程/3：图书/4：问答
          id: id
        }).then(data => { })
        .catch(() => {
        })
      // 路由跳转
      this.$router.push(
        { name: 'questionInfo', query: { id: id } }
      )
    },
    // 按标签查询
    handleEvent (search) {
      this.currentPage = 1
      this.dataForm.tagId = search.id
      this.changePageTo(this.currentPage)
      this.routerPush({
        tagId: this.dataForm.tagId,
        page: this.currentPage,
        childIndex: search.index
      })
    },
    // 分页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: this.currentPage
        })
        // this.getList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    clickPageTo (page) {
      this.changePageTo(page)
      this.routerPush({
        page: page
      })
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        // this.getList(newCurrent)
        this.changePageTo(newCurrent)
        this.routerPush({
          page: this.currentPage
        })
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      // this.getList()
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.changePageTo(this.currentPage)
        this.routerPush({
          page: this.currentPage
        })
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped lang="scss">
.all-left-wrap {
  width: 870px;
  min-height: 1531px;
  float: left;
  background: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.all-question {
  font-weight: normal;
  margin: 20px 0;
  font-size: 26px;
  border-bottom: 1px solid #ccc;
}
.question-classify {
  background: #fff;
  height: 41px;
  line-height: 41px;
  border-bottom: 1px solid #1d65a8;
}
.question-classify ul {
  width: 100%;
  height: 40px;
}
.question-classify ul li {
  float: left;
  padding: 0 30px;
  color: #333;
  cursor: pointer;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  line-height: 40px;
  height: 40px;
}
.question-classify ul li.checked {
  background: #1d65a8;
  color: #fff;
}
.question-list {
  width: 100%;
}
.question-list ul li {
  border-bottom: 1px solid #e2e2e2;
  margin-top: 30px;
  padding-bottom: 30px;
  min-height: 133px;
  overflow: hidden;
}
.person {
  float: left;
  width: 100px;
  height: 85px;
  text-align: center;
  margin-right: 30px;
}
.person img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-bottom: 10px;
}
.person p {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.question-con {
  min-height: 80px;
  float: left;
  width: 740px;
}
.question-left {
  width: 590px;
  float: left;
}
.question-left h3 {
  height: 30px;
  line-height: 30px;
  font-weight: normal;
  cursor: pointer;
  width: 590px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.question-left h3:hover {
  color: #1d65a8;
}
// 回答数浏览数
.question-right {
  float: right;
  width: 120px;
  height: 50px;
  margin-top: 20px;
  text-align: center;
}
.answer-number {
  float: left;
  width: 42px;
  height: 42px;
}
.review-number {
  float: left;
  margin-left: 10px;
  width: 42px;
  height: 42px;
}
.question-latest {
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.question-time {
  margin-top: 15px;
}
.question-right-wrap {
  padding-left: 10px;
  margin-top: 30px;
  width: 290px;
  height: 666px;
}
.all-list-wrap {
  margin-top: 10px;
  min-height: 60px;
}
.list-tag {
  background: #f2efed;
  color: #787d82;
  float: left;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  margin-right: 5px;
  margin-bottom: 5px;
}
.hot-question {
  margin: 20px 0;
  text-align: left;
  border-bottom: 1px solid #e2e2e2;
  height: 34px;
}
.hot-question h4 {
  line-height: 34px;
  padding: 0 10px;
  color: #666;
  font-size: 18px;
  font-weight: normal;
}
.hot-question-list {
  width: 280px;
  height: 473px;
}
.hot-question-list ul {
  width: 280px;
  height: 473px;
}
.hot-question-list ul li {
  border-bottom: 1px dotted #e2e2e2;
  margin-top: 15px;
  height: 46px;
  width: 280px;
}
.hot-question-title {
  float: left;
  width: 200px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hot-question-answear {
  float: right;
  width: 50px;
  height: 40px;
  text-align: center;
}
.hot-question-answear .red {
  color: #ff3116;
}
.new-answer {
  color: #ccc;
  margin-right: 5px;
}
.question-att {
  background: #f2efed;
  color: #787d82;
  display: inline-block;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  margin-right: 5px;
}
.best-answer {
  color: #09b242;
}
</style>
